import React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Radio } from 'antd';
const RadioGroup = Radio.Group;

class DigestMode extends React.Component{
  constructor(props){
    super(props);
    this.state={
      value: ""
    }
  }

  componentDidMount(){
    // load digest mode from the props.parameters.digestMode
    if(this.state.value !== this.props.parameters.digestMode){
      this.setState({value: this.props.parameters.digestMode})
    }
  }

  onChange=(e)=>{
    // console.log(e.target.value);
    // update local state
    this.setState({value: e.target.value});
    // update parent component state
    this.props.updateParameters({digestMode: e.target.value});
  }

  render(){
    // console.log(this.props);
    const {value} = this.state;
    return(
      <>
        <div css={css`
          font-size: 1.0rem;
          font-weight: 600;
          padding: 15px 0;
        `}>Select a digestion mode</div>

        <RadioGroup onChange={this.onChange} value={value}>
          {
            this.props.digestModeList.map((mode, index)=><Radio key={index} value={mode.index}>{mode.name}</Radio>)
          }
        </RadioGroup>
      </>
    )
  }
}

export default DigestMode;

DigestMode.defaultProps = {
  parameters: {
    digestMode: ""
  }
}